import { InfoOrderDetailTypes } from 'redux/ordersDetails/types';

export type HandleFieldKey = keyof InfoOrderDetailTypes | 'order_type';

export type HandleFieldValue =
  | InfoOrderDetailTypes[keyof InfoOrderDetailTypes]
  | string
  | number
  | boolean
  | null
  | Date
  | undefined;

interface WorkerContractInfo {
  status?: string | null;
  number?: string | null;
}

export interface SelectedWorker {
  id: number;
  name: string;
  surname: string;
  patronymic?: string | null;
  phone?: string | null;
  inn?: string | null;
  unified_contract?: WorkerContractInfo | null;
}

export interface CreateOrderFormErrors {
  type: string | null;
  description: string | null;
  amount: string | null;
  address: string | null;
  employee?: string | null;
  max_value: string | null;
  contract_kind?: string | null;
  date_start?: string | null;
  date_end?: string | null;
}

interface OrderTemplateInfo {
  id: number;
  name: string;
}

interface ServiceType {
  id: number;
  name: string;
  description?: string | null;
  can_be_remote: 0 | 1 | null;
}

interface TypesOfServicesResponse {
  items?: ServiceType[];
  default?: ServiceType;
}

interface CreateOrderTemplateResponse {
  id: number;
}

export const isServiceType = (item: unknown): item is ServiceType =>
  typeof item === 'object' &&
  item !== null &&
  'id' in item &&
  typeof (item as { id: unknown }).id === 'number' &&
  'name' in item &&
  typeof (item as { name: unknown }).name === 'string';

export const isServiceTypeArray = (items: unknown): items is ServiceType[] =>
  Array.isArray(items) && items.every((item) => isServiceType(item));

export const isTypesOfServicesResponse = (
  data: unknown,
): data is TypesOfServicesResponse =>
  typeof data === 'object' && data !== null && ('items' in data || 'default' in data);

export const isOrderTemplateArray = (
  templates: unknown,
): templates is OrderTemplateInfo[] =>
  Array.isArray(templates) &&
  templates.every(
    (template) =>
      typeof template === 'object' &&
      template !== null &&
      'id' in template &&
      typeof (template as { id: unknown }).id === 'number' &&
      'name' in template &&
      typeof (template as { name: unknown }).name === 'string',
  );

export const isCreateOrderTemplateResponse = (
  payload: unknown,
): payload is CreateOrderTemplateResponse =>
  typeof payload === 'object' &&
  payload !== null &&
  'id' in payload &&
  typeof (payload as { id: unknown }).id === 'number';

export interface CreateOrderFormProps {
  handleFieldChange: (key: HandleFieldKey, value: HandleFieldValue) => void;
  errors: CreateOrderFormErrors;
  selectedWorker?: SelectedWorker | null;
  clearErrorForField?: (key: HandleFieldKey) => void;
  clearError?: (field: keyof CreateOrderFormErrors) => void;
  setErrorCountDescription?: (value: boolean) => void;
}
